import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './Component/loader/loader.component';
import { LoaderService } from './Component/loader/loader.service';
import { AuthenticationService } from './core/services/auth.service';
import { SettingsService } from './core/services/settings.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Línea de Crédito';

  isValidandoToken = true;
  isNewToken = false;
  cantidadValidacion = 0;

  private loaderService = inject(LoaderService);
  private route = inject(ActivatedRoute);
  private authService = inject(AuthenticationService);
  private settingsService = inject(SettingsService);
  private router = inject(Router);

  ngOnInit(): void {
    this.loaderService.showLoader(false);
    this.isValidandoToken = true;
    this.listenerToken();
    this.validarSession();
  }

  /**
   * Escucha el evento message en la ventana actual y verifica que
   * el origen sea del Back Office. Si es asi,
   * obtiene el token del evento y lo almacena en el servicio de sesion.
   */
  listenerToken() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.isNewToken = true;
        this.authService.setToken(token);
        // Limpiar el token de la URL para que no quede en historial/logs
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true,
        });
      }
    });
  }

  /**
   * Verifica si existe una sesion guardada en localStorage,
   * si es asi, llama a validarToken() para verificar el token.
   * Si no existe verifica si existe un token en el servicio de auth, si existe llama a validarToken(),
   * si no existe redirige a la pagina de login del Back Office.
   */
  validarSession() {
    if (localStorage.getItem('session')) {
      this.validarToken();
    } else {
      setTimeout(() => {
        const token = this.authService.getAccessToken();
        if (token) {
          this.validarToken();
        } else {
          window.location.href = this.settingsService.LOGIN_URL;
        }
      }, 2000);
    }
  }

  validarToken() {
    this.authService.validarToken(2).subscribe(
      (res: any) => {
        if (res.success && res.usuarioId) {
          this.authService.userId = res.usuarioId;
        }
        this.isValidandoToken = false;
        this.router.navigate(['']);
      },
      _error => {
        if (this.cantidadValidacion < 2) {
          this.cantidadValidacion++;
          if (!this.isNewToken) {
            localStorage.clear();
          }
          this.validarSession();
        } else {
          this.authService.logout();
        }
      },
    );
  }
}
